import { useEffect, useState, useCallback } from "react";

export function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
export function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}

// Reads the globally-captured beforeinstallprompt event (see index.js) so the
// install affordance works anywhere in the app, not just where it was first fired.
export function usePwaInstall() {
  const [canInstall, setCanInstall] = useState(!!window.__pwaDeferred);
  const [standalone] = useState(isStandalone());
  useEffect(() => {
    const on = () => setCanInstall(!!window.__pwaDeferred);
    const off = () => setCanInstall(false);
    window.addEventListener("pwa-can-install", on);
    window.addEventListener("appinstalled", off);
    return () => { window.removeEventListener("pwa-can-install", on); window.removeEventListener("appinstalled", off); };
  }, []);
  const promptInstall = useCallback(async () => {
    const d = window.__pwaDeferred;
    if (!d) return false;
    d.prompt();
    await d.userChoice;
    window.__pwaDeferred = null;
    setCanInstall(false);
    return true;
  }, []);
  return { canInstall, standalone, ios: isIOS(), promptInstall };
}
